import React from 'react'
import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'


import './hero.css'

function HeroHeader() {

  const heroTitle = useRef(null)

  useEffect(() => {
     heroTitle.current.innerHTML = heroTitle.current.textContent.replace(/\S/g, "<span class='letter'>$&</span>")
     gsap.from('.hero-title span', {
        duration: 0.8,
        opacity: 0,
        delay: 0.5,
        ease: "power4.out",
        y: 150,
        stagger: {
          amount: 1
        }
     })
  }, [heroTitle])

  return (
        <div className='hero-container'>
            <h1 ref={heroTitle} className="hero-title serif">
              we are lustore
            </h1>
        </div>
  )
}

export default HeroHeader